import React from 'react';
import { Link } from 'react-router-dom';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Menu } from 'antd';

const GuestMenu: React.FC = (): React.ReactElement => (
  <Menu theme="dark" mode="inline">
    <Menu.Item key="1">
      <Link to="/">
        <LegacyIcon type="time" />
        <span>Login</span>
      </Link>
    </Menu.Item>
  </Menu>
);

export default GuestMenu;
